module.exports = __webpack_public_path__ + "img/ecedo.a980532d.png";